<template>
  <div class="box">
    <Echart
      id="leftCenterChart"
      :options="options"
      height="320px"
      width="550px"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      number: 0,
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow", textStyle: { color: "#fff" } }
          },
          grid: {
            top: "10%",
            left: "0%",
            right: "18%",
            bottom: "24%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              axisLine: { lineStyle: { color: "#0177d4" } },
              splitLine: { show: false },
              axisTick: { show: false },
              splitArea: { show: false },
              axisLabel: { interval: 0, color: "#fff", fontSize: 16 },
              data: ["总行"]
            }
          ],
          yAxis: [
            {
              // type: "value",
              axisLine: { show: false, lineStyle: { color: "#144088" } },
              splitNumber: 1,
              // axisTick: { show: false },
              // axisLabel: { interval: 0, color: "#30ABE7", fontSize: 14 },
              // splitArea: { show: false },
              // splitLine: { show: true, lineStyle: { color: "#144088" } }
            },
            {
              name: "尾箱数量",
              nameTextStyle: {
                color: "#0195F2",
                fontSize: 14,
                position: "right",
                padding: [10, 4, 0, -30]
              },
              axisLine: { show: false },
              axisTick: { show: false }
            }
          ],
          series: [
            {
              name: "尾箱数量",
              type: "bar",
              barMaxWidth: 12,
              barGap: "10%",
              itemStyle: {
                normal: {
                  color: {
                    colorStops: [
                      { offset: 0, color: "#0173ff" },
                      { offset: 0.8, color: "#03fef1" }
                    ],
                    x: 0,
                    y: 1,
                    x2: 0,
                    y2: 0,
                    type: "linear",
                    global: false
                  }
                }
              },
              label: {
                normal: {
                  show: true,
                  lineHeight: 30,
                  width: 80,
                  height: 30,
                  color: "#1FFFF2",
                  position: ["2", "-30"],
                  fontSize: 14
                }
              },
              data: [1]
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss" scope>
.box {
  width: 100%;
  height: 100%;
  margin-top: 10px;
  // margin-left: 50px;
  .tit {
    float: left;
    margin-top: 18px;
    font-size: 28px;
  }
  .title {
    float: right;
    margin-top: -40px;
    margin-right: 56px;
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/screen/components/leftCenterChart/index.vue